'use strict';

angular.module('ringbaPortal')
  .filter('applyFilter', function ($filter) {
    'ngInject';
    
    return function (data, filterName, filterOption) {
      if (filterName === 'percent') {
        return $filter('number')(data * 100, filterOption || 2) + '%';
      }
      if (filterName === 'currency') {
        // Display fractions of a cent if present
        const tokens = data.toString().split('.');
        if (tokens.length > 1 && tokens[1].length > 2) {
          return $filter('currency')(data, '$', filterOption || 2);
        } else {
          return $filter('currency')(data);
        }
      }

      return $filter(filterName)(data);
    };
  });
